(function () {
	'use strict';
	var controllerId = 'choiceAdd';
	var urlAPI = '/api';
	angular.module('app').controller(controllerId, ['$scope', '$q', "bootstrap.dialog", 'Upload', 'common', '$uibModalInstance', 'datacontext', 'sectionMenu', 'question', 'choice', 'testId', 'dataType', '$translate', choiceAdd]);



	function choiceAdd($scope, $q, bDialog, Upload, common, $uibModalInstance, datacontext, sectionMenu, question, choice, testId, dataType, $translate) {
	    var getLogFn = common.logger.getLogFn;
	    var log = getLogFn(controllerId);
	    var logError = getLogFn(controllerId, 'logError');
	    var logSuccess = getLogFn(controllerId, 'logSuccess');

	    $scope.scoreMin = 1;
	    $scope.scoreMax = 3;
	    $scope.dataType = dataType;
	    $scope.question = question;
	    $scope.testId = testId;
	    
	    if (typeof (choice) == 'undefined' ||
			((typeof (choice.Id) == 'undefined' || choice.Id == 0) && ((typeof (choice.bNew) == 'undefined') || (choice.bNew == true)))) {
	        $scope.choice = {};
	        $scope.choice.Id = 0;
	        $scope.choiceOrig = choice;
	        $scope.choice.image = null;
	        $scope.action = 'Add';
	        $scope.choice.layout = 3;			
	        if (dataType == 'Q') {
	            $scope.popupTitle = 'AggiungiDomanda';
	            $scope.item = 'Domanda';
	            $scope.choice.score = $scope.scoreMin;
	        } else {
	            $scope.popupTitle = 'AggiungiOpzione';
	            $scope.item = 'risposta';
	            $scope.choice.questionId = question.Id;
	            $scope.choice.correct = 0;
	            $scope.choice.score = $scope.scoreMin;
	        }
	        $scope.thumb = "";
	    } else {

	        $scope.choiceOrig = choice;
	        $scope.choice = jQuery.extend({}, choice);
	        $scope.choice.image = typeof ($scope.choice.imgPath) == 'undefined' || $scope.choice.imgPath == "" ? null : $scope.choice.imgPath;
	        $scope.action = 'Edit';
	        if (dataType == 'Q'){
	            $scope.popupTitle = 'ModificaDomanda';
	            $scope.item = 'Domanda';
	        }
	        else {
	            $scope.popupTitle = 'ModificaOpzione';
	            $scope.choice.questionId = question.Id;
	            $scope.item = 'Risposta';//sistemato
	        }
	    }

	    //****************************************************
	    /*CROP IMAGE 2*/
	    //****************************************************	    
	    $scope.cropParam = {};
	    $scope.cropParam.imageUrl = $scope.choice.imgPath;
	    $scope.cropParam.imageResult = '';
	    $scope.cropParam.showControls = true;
	    $scope.cropParam.fit = true;
	    $scope.cropParam.widthAttempt = 390;
	    $scope.cropParam.heightAttempt = 280;
		
	    $scope.bUploadNewImage = false;
	    setMaxLength(false);        
	    function setMaxLength(forceImage) {
	        var withImage = forceImage || ($scope.cropParam.imageResult != '' || $scope.choice.image != null);
	        if (dataType == 'Q') {
	            if (withImage == false)
	                $scope.maxLength = 400; //DOMANDA : solo Testo
	            else {
	                $scope.maxLength = 200; //DOMANDA : Testo + Immagine
	                if (typeof ($scope.choice.text) != 'undefined' && $scope.choice.text != null && $scope.choice.text.length > 0) {
	                    var countChars = $scope.choice.text.length;
	                    if (countChars > $scope.maxLength) {
	                        var tmpText = $scope.choice.text.substring(0, $scope.maxLength); //Tronco il testo
	                        $scope.choice.text = tmpText;
	                        var msg = $translate.instant('NumeroCaratteriDisponibili')+' 200, '+$translate.instant('StatoTroncato')+'.';
	                        bDialog.confirmationDialog($translate.instant('Attenzione'), msg, $translate.instant('Conferma'), " ");
	                    }
	                }
	            }

	        } else {
	            if (withImage == false)
	                $scope.maxLength = 120; //OPZIONE : solo Testo
	            else {
	                $scope.maxLength = 60; //OPZIONE : Testo + Immagine
	                if (typeof ($scope.choice.text) != 'undefined' && $scope.choice.text != null && $scope.choice.text.length > 0) {
	                    var countChars = $scope.choice.text.length;
	                    if (countChars > $scope.maxLength) {
	                        var tmpText = $scope.choice.text.substring(0, $scope.maxLength); //Tronco il testo
	                        $scope.choice.text = tmpText;
	                        var msg = $translate.instant('NumeroCaratteriDisponibili') + ' 60, ' + $translate.instant('StatoTroncato') + '.';
	                        bDialog.confirmationDialog($translate.instant('Attenzione'), msg, $translate.instant('Conferma'), " ");
	                    }
	                }
	            }
	        }
	    }

	    function setLayout(forceImage) {	        
	        var withImage = forceImage || ($scope.cropParam.imageResult != '' || $scope.choice.image != null); // $scope.choice.imgPath != null || $scope.choice.image != null
	        var withText = (typeof ($scope.choice.text) != 'undefined' && $scope.choice.text != null && $scope.choice.text.length > 0); // $scope.choice.imgPath != null || $scope.choice.image != null
	        if (withText) {
	            if (withImage) {
	                if ($scope.choice.layout < 3)
	                    $scope.choice.layout = 3;
	            }
	            else
	                $scope.choice.layout = 1;
					
	        } else
	        {
	            if (withImage) 
	                $scope.choice.layout = 2;
	            else
	                $scope.choice.layout = 1; //Se � senza testo e senza immagine riporto il layout a 1
	        }
	    }
		
	    $scope.optionlistClick = function () {
	        if (typeof ($scope.optionlist) == 'undefined' || $scope.optionlist == false)
	            $scope.optionlist = true;
	        else
	            $scope.optionlist = false;
	    }
		
	    $scope.optionDefChoices = function (index, nameSource) {
	        //console.log('optionDefChoices');
	        $scope.choice.defaultChoice = index;
	        //console.log($('#optionDefChoicesSelected').html());
	        //console.log($('#' + nameSource).html());
	        $('#optionDefChoicesSelected').html($('#' + nameSource).html());
	        //console.log($('#optionDefChoicesSelected').html());
	        return false;
	    }

	    $scope.imageLoaded = function (file) {	        
	        $scope.cropper.sourceImage = file;
	        $scope.cropper.croppedImage = file;
	        //setLayout(true);
	        setMaxLength(false);

	        //$scope.choice.imgPath = file;
	    }
		

	    $scope.layouts = [
			{ Id: 3, Name: $translate.instant('TestoSopra') },
            { Id: 4, Name: $translate.instant('TestoSotto') }
	    ];

	    $scope.defaultChoices = [
			{ Id: 1, Name: $translate.instant('Vero')+','+$translate.instant('Falso') },
			{ Id: 2, Name: $translate.instant('Si') + ',' + $translate.instant('No') }
	    ];

	    $scope.howToSend = 1;

	    $scope.$watch("cropParam.imageResult", function changeValue(newValue, oldValue) {
	        if (typeof ($scope.firstWatch1) == 'undefined')
	            $scope.firstWatch1 = 0;
	        else {
	            $scope.newImage = (oldValue != null && oldValue != '');
	        }
	        
	    });

	    $scope.$watch("choice.image", function changeValue(newValue, oldValue) {
	        if (common.detectIE()) {
	            if (window.navigator.userAgent.indexOf("Edge/") <= 0) {
	                document.getElementById("image").contentEditable = "true";
	                if ($scope.choice.image) {
	                    document.getElementById("image").contentEditable = "false";
	                }
	            }
	        }

	        //escludo il primo accesso
	        if (typeof ($scope.firstWatch) == 'undefined')
	            $scope.firstWatch = 0;
	        else {
	            $scope.bUploadNewImage = (newValue != null);
	            setMaxLength($scope.bUploadNewImage);
	            setLayout($scope.bUploadNewImage);
	        }
	    });

	    $scope.reset = function (){
	        document.getElementById('image_file').value = null;
	    }

	    $scope.ok = function (isValid) {	        
	        var file = $scope.cropParam.imageResult;
	        setLayout(false);
	        var result = null;
	        if (isValid) {
	            return $q.when($scope.uploadPic(file)).then(function (uploadResult) {					
	                return $q.when(addItem($scope.choice)).then(function (data) {
	                    result = data;
	                    if (uploadResult == true)
	                        result.image = file;
	                    if (dataType == 'Q' && typeof($scope.choice.defaultChoice) != 'undefined' && $scope.choice.defaultChoice != '')
	                    {
	                        result = setChoices(result, $scope.choice.defaultChoice);
	                    }
							
	                    $uibModalInstance.close(result);
	                });

	                return false;
	            });
	        }
	    };

	    $scope.cancel = function () {
	        $uibModalInstance.dismiss('cancel');
	    };

	    $scope.toggleScoreBit = function () {
	        $scope.choice.correct = ($scope.choice.correct ? false : true);
	    }

	    $scope.eraseImage = function (file) {
	        $scope.choice.imgPath = null;
	        $scope.choice.image = null;
	        $scope.cropParam.imageResult = '';
	        setMaxLength(false);
	    }

	    $scope.eraseText = function () {	        
	        $scope.choice.text = '';
	        setLayout(false);
	        setMaxLength(false);
	    }

	    function addItem(item) {
	        setLayout(false);

	        if ($scope.dataType == 'C' && $scope.scoreBit == false)
	            $scope.choice.score = 0;

	        return $scope.choiceOrig = jQuery.extend({}, $scope.choice); //clona oggetto in memoria
	    }

	    function setChoices(result, defaultChoice)
	    {	        
	        result.choices = [];
	        //Item : choices with Default Values					
	        switch (defaultChoice)
	        {
	            case 1: //[Vero], Falso
	                //opzione 1
	                var item = { Id: 0, questionId: 0, imgPath: '', imgName: '', imgByte: 0, layout: 1, correct: true, text: $translate.instant('Vero') };
	                result.choices.push(item);
	                //opzione 2
	                var item = { Id: 0, questionId: 0, imgPath: '', imgName: '', imgByte: 0, layout: 1, correct: false, text: $translate.instant('Falso') };
	                result.choices.push(item);

	                break;
	            case 2: //Vero, [Falso]
	                //opzione 1
	                var item = { Id: 0, questionId: 0, imgPath: '', imgName: '', imgByte: 0, layout: 1, correct: false, text: $translate.instant('Vero') };
	                result.choices.push(item);
	                //opzione 2
	                var item = { Id: 0, questionId: 0, imgPath: '', imgName: '', imgByte: 0, layout: 1, correct: true, text: $translate.instant('Falso') };
	                result.choices.push(item);
	                break;
	        }

	        return result;
	    }

        $scope.uploadPic = function (file) {            
	        if ($scope.bUploadNewImage || $scope.newImage) //non � stata apportata nessuna variazione all'immagine
            {			    
	            if (typeof (file) != 'undefined' && file != '') {

	                var filename = $('#image_file').val();				    
	                if (typeof (filename) == 'undefined' || filename == '' || filename == null)
	                    filename = $scope.choice.imgName;

	                //se faccio copia e incolla $scope.choice.imgName == null
	                //quindi imposto un nome file fittizio
	                if (typeof (filename) == 'undefined' || filename == '' || filename == null)
	                    filename = 'C:\\fakepath\\Immagine.jpg';


	                //console.info('file', file, filename);
	                if (dataType == 'Q') {
	                    return $q.when(datacontext.question_upload(filename, file)).then(function (data) {
	                        //if (data.length > 0) {
	                        $scope.choice.imgPath = data.PathServer;
	                        $scope.choice.imgName = data.NameOrig;
	                        $scope.choice.imgByte = data.Length;
	                        $scope.choice.image = file;
	                        //}
	                        return true;
	                    });

	                } else if (dataType == 'C') {
	                    return $q.when(datacontext.choice_upload(filename, file)).then(function (data) {
	                        //if (data.length > 0) {
	                        $scope.choice.imgPath = data.PathServer;
	                        $scope.choice.imgName = data.NameOrig;
	                        $scope.choice.imgByte = data.Length;
	                        $scope.choice.image = file;
	                        //}
	                        return true;
	                    });
	                }
	            }
	            else {	                
	                $scope.choice.imgPath = null;
	                $scope.choice.imgName = null;
	                $scope.choice.imgByte = 0;
	                $scope.choice.image = null;
	            }
	        }			

	        return false;
        };

        $scope.abilitaTextarea = function () {
            $('#text').css('border', 'solid 1px #4A95D3');

            var image = angular.element(document.querySelector('#image'));
            image.removeClass('cpimg-active');
            image.removeClass('cpimg-contain');

            $(document).click(function (e) {
                if ($(e.target).closest('textarea').length == 0) {
                    $('#text').css('border', 'solid 1px #ccc');
                }
            });
        };
	}
})();